export default "__VITE_ASSET__Db1Zy2A___"